module.exports = __webpack_public_path__ + "static/media/(000050).682cdb9e.jpg";